import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { ProfileComponent } from './components/profile/profile.component';
import { GtapMaterialsModule } from '../gtap-materials/gtap-materials.module';


@NgModule({
  declarations: [ProfileComponent],
  imports: [
    CommonModule,
    GtapMaterialsModule,
    UserRoutingModule
  ]
})
export class UserModule { }
